export default {
  FIELD_MUST_BE_NOT_EMPTY: "Il campo è obbligatorio",
  FIELD_MUST_BE_LESS_THAN_500: "Il campo deve contenere meno di 500 caratteri",
  FIELD_MUST_BE_LESS_THAN_64: "Il campo deve contenere meno di 64 caratteri",
  FIELD_MUST_BE_LESS_THAN_256: "Il campo deve contenere meno di 256 caratteri",
  RETIRE_DATE_MUST_BE_AFTER_PUBLISH_DATE:
    "La data di ritiro deve essere dopo quella di pubblicazione",
  PUBLISH_DATE_MUST_BE_AFTER_CURRENT_TIME:
    "La data di pubblicazione deve essere superiore a quella corrente",
  RETIRE_DATE_MUST_BE_AFTER_CURRENT_TIME:
    "La data di ritiro deve essere superiore a quella corrente"
};
